import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Clock, Instagram } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="bg-[#1A231C] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 bg-[#2C5530] rounded-full flex items-center justify-center">
                <span className="font-bold text-lg">GF</span>
              </div>
              <div>
                <span className="font-cabinet font-bold">GAMA FOODS</span>
                <span className="block text-xs text-[#808E83]">Chiloé · Sabores Artesanales</span>
              </div>
            </div>
            <p className="text-sm text-[#808E83] mb-4">
              Productos frescos y artesanales del sur de Chile. Desde Chonchi para toda la isla de Chiloé, desde 1985.
            </p>
            <div className="flex gap-3">
              <a
                href="https://www.instagram.com/gamafoodschiloe/"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 text-sm text-[#808E83] hover:text-white transition-colors"
              >
                <Instagram size={18} />
                @gamafoodschiloe
              </a>
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="font-cabinet font-semibold mb-4">Navegación</h4>
            <nav className="space-y-2">
              <Link to="/" className="block text-sm text-[#808E83] hover:text-white transition-colors">Inicio</Link>
              <Link to="/productos" className="block text-sm text-[#808E83] hover:text-white transition-colors">Productos</Link>
              <Link to="/nosotros" className="block text-sm text-[#808E83] hover:text-white transition-colors">Nosotros</Link>
              <Link to="/sala-venta" className="block text-sm text-[#808E83] hover:text-white transition-colors">Sala de Venta</Link>
              <Link to="/login" className="block text-sm text-[#808E83] hover:text-white transition-colors">Acceso B2B</Link>
            </nav>
          </div>

          {/* Categories */}
          <div>
            <h4 className="font-cabinet font-semibold mb-4">Productos</h4>
            <nav className="space-y-2">
              <Link to="/productos?categoria=espacio-fresco" className="block text-sm text-[#808E83] hover:text-white transition-colors">Espacio Fresco</Link>
              <Link to="/productos?categoria=pan" className="block text-sm text-[#808E83] hover:text-white transition-colors">Pan Fresco</Link>
              <Link to="/productos?categoria=frutas" className="block text-sm text-[#808E83] hover:text-white transition-colors">Frutas</Link>
              <Link to="/productos?categoria=verduras" className="block text-sm text-[#808E83] hover:text-white transition-colors">Verduras</Link>
              <Link to="/productos?categoria=congelados" className="block text-sm text-[#808E83] hover:text-white transition-colors">Congelados</Link>
              <Link to="/productos?categoria=gourmet" className="block text-sm text-[#808E83] hover:text-white transition-colors">Gourmet</Link>
            </nav>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-cabinet font-semibold mb-4">Contacto</h4>
            <div className="space-y-3">
              <div className="flex items-start gap-3 text-sm">
                <MapPin size={18} className="text-[#808E83] flex-shrink-0 mt-0.5" />
                <div>
                  <p>Pedro Aguirre Cerda #0194</p>
                  <p className="text-[#808E83]">Chonchi, Chiloé</p>
                </div>
              </div>
              <div className="flex items-start gap-3 text-sm">
                <Clock size={18} className="text-[#808E83] flex-shrink-0 mt-0.5" />
                <div>
                  <p>Lun-Sáb: 8:00 - 20:00</p>
                  <p>Dom: 9:00 - 19:00</p>
                </div>
              </div>
              <a
                href="https://wa.me/56994798582?text=Hola!+Quiero+hacer+un+pedido"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 bg-[#25D366] hover:bg-[#1EBE5D] text-white font-medium text-sm px-4 py-2 rounded-full transition-colors mt-2"
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
                </svg>
                WhatsApp
              </a>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-12 pt-8 border-t border-white/10 text-center">
          <p className="text-sm text-[#808E83]">
            © 2026 Gama Foods Chiloé · Todos los derechos reservados
          </p>
          <p className="text-xs text-[#808E83] mt-1">
            Hecho con amor en Chonchi, Chiloé
          </p>
        </div>
      </div>
    </footer>
  );
}
